import { API } from "aws-amplify";

const loginlog = async (params) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  let res = await API.post("NoPermissionAPI", "/smart/loginlog", myInit);

  return res;
};
const loginlogSuccess = async (params) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  let res = await API.post("InasakuAPI", "/api/payment/login", myInit);

  return res;
};

export default {
  loginlog: loginlog,
  loginlogSuccess: loginlogSuccess,
};
